import { Injectable } from '@angular/core';

import { Task } from './task';
import { TASKS } from './tasks';
import { MOCKTASKS } from './mock-tasks';

@Injectable()
export class MondayTasksService {

  getTasks(): Promise<Task[]> {
    return Promise.resolve(TASKS);
  }

  getMockTasks(): Promise<Task[]> {
    return Promise.resolve(MOCKTASKS);
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/monday-tasks/monday-tasks/monday-tasks.service.ts